import { isEmpty, unique, type CompanyData, type TeamData, type TeamLevel } from '@terros/common'
import { type SelectItem } from '../types'
import { getLevelName } from '../data'

export type AvailableLevels = { highestLevel: TeamLevel; lowestLevel: TeamLevel; levels: TeamLevel[] }

export const getOptionalAvailableLevels = (allTeams: TeamData[] | undefined): AvailableLevels | undefined => {
  if (isEmpty(allTeams)) return undefined
  return getAvailableLevels(allTeams)
}

export const getAvailableLevels = (allTeams: TeamData[]): AvailableLevels => {
  const levels = unique(allTeams.map((team) => team.level)).sort((a, b) => b - a)
  const highestLevel = Math.max(...levels)
  const lowestLevel = Math.min(...levels)
  return { highestLevel, lowestLevel, levels }
}

export const toTeamLevelSelectOptions = (
  company: CompanyData | undefined,
  levels: TeamLevel[]
): SelectItem<TeamLevel>[] => {
  if (isEmpty(levels)) return []
  return levels.map((level) => ({
    label: getLevelName(company, level),
    value: level,
  }))
}
